import React, { useState } from 'react'
import styled from 'styled-components'
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { selectCars } from "../features/car/carSlice";
import { useSelector } from 'react-redux';


function Header() {

    const [burgerStatus, setBurgerStatus] = useState(false);
    const cars = useSelector(selectCars)

    return (
        <Container>
            <a href="#">
                <img src="/images/logo.svg" alt="Logo" />
            </a>

            <Menu>
                { cars && cars.map((car,index) =>(
                    <a key={index} href="#">{car}</a>
                 ))}
                {/* <a href="#">Model S</a>
                <a href="#">Model 3</a>
                <a href="#">Model X</a>
                <a href="#">Model Y</a> */}
            </Menu>

            <RightMenu>
                <a href="#">Shop</a>
                <a href="#">Tesla Account</a>
                <CustomMenu onClick = {()=> setBurgerStatus(true) }/>
            </RightMenu>
            <BurgerMenu show={ burgerStatus }>
                <CloseWrap>
                    <CloseButton onClick = {()=> setBurgerStatus(false)} />
                </CloseWrap>
                { cars && cars.map((car,index) =>(
                    <li key={index}><a href="#">{car}</a></li>
                 ))}
        
                <li><a href="#">Existing inventory</a></li>
                <li><a href="#">Used inventory</a></li>
                <li><a href="#">Trade-in</a></li>
                <li><a href="#">Cybertruck</a></li>
                <li><a href="#">Semi</a></li>
                <li><a href="#">Charging</a></li>
                <li><a href="#">PowerWall</a></li>
                <li><a href="#">Commercial Energy</a></li>
                <li><a href="#">Utilities</a></li>
                <li><a href="#">Find Us</a></li>
                <li><a href="#">Support</a></li>
                <li><a href="#">United States</a></li>
            </BurgerMenu>
        </Container>
    )
}

export default Header

const Container = styled.div`
    min-height: 60px;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
`

const Menu = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    a {
        font-weight: 600;
        text-Transform: uppercase;
        padding: 0 10px;
    }
    @media (max-width:768px){
        display: none;
    }

`

const RightMenu = styled.div`
    display: flex;
    align-items: center;
    a {
        font-weight: 600;
        text-Transform: uppercase;
        margin-right: 10px;
    }
`

const CustomMenu = styled(MenuIcon)`
    cursor: pointer;
`

const BurgerMenu = styled.div `
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: white;
    width: 300px;
    z-index: 10;
    list-style: none;
    padding: 10px;
    text-align: left;
    transform: ${ props => props.show ? 'translateX(0)' : 'translateX(100%)'};
    transition: transform 0.2s ;

    li {
        padding: 15px 0;
        border-bottom: 1px solid rgba(0,0,0, .2);

        a{
            font-weight: 600;
        }
    }
`

const CloseButton = styled(CloseIcon) `
    cursor: pointer;
`

const CloseWrap = styled.div `
    padding-top: 9px;
    padding-right: 7px;
    display:flex;
    justify-content: flex-end;
`
